// Transaction Wizard — the look. Colours ride the app's CSS variables (the same
// tokens and fallbacks as Line Entry's styles), so a themed application keeps
// its own accent; handheld targets are at least 48px tall.

import type { CSSProperties } from 'react'
import { T } from '../txn/lineEntry/styles'

export { T }

export const GOOD = { bg: '#e6f4ec', fg: '#136c3a', border: '#b7dfc6' }
export const BAD = { bg: '#fde8e8', fg: '#a61b1b', border: '#f3c0c0' }
export const WARN = { bg: '#fff4e0', fg: '#8a4b00', border: '#f2d3a0' }
export const INFO = { bg: '#e8f0fe', fg: '#0b3f86', border: '#b9cff5' }

export function button(handheld: boolean, primary = false, disabled = false): CSSProperties {
  return {
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6,
    minHeight: handheld ? 48 : 36, padding: handheld ? '0 18px' : '0 14px',
    borderRadius: 8, border: `1px solid ${primary ? 'transparent' : T.border}`,
    background: primary ? T.accent : T.bg, color: primary ? '#fff' : T.text,
    fontFamily: 'inherit', fontSize: handheld ? 16 : 14, fontWeight: 600,
    cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.5 : 1,
    whiteSpace: 'nowrap', boxSizing: 'border-box',
  }
}

export const card: CSSProperties = {
  border: `1px solid ${T.border}`, borderRadius: 10, background: T.bg, padding: 14,
}

export const muted: CSSProperties = { color: T.muted, fontSize: 14 }

export function banner(tone: { bg: string; fg: string; border: string }): CSSProperties {
  return {
    background: tone.bg, color: tone.fg, border: `1px solid ${tone.border}`, borderRadius: 8,
    padding: '10px 12px', fontSize: 15, display: 'flex', alignItems: 'flex-start', gap: 8,
  }
}

export const input = (handheld: boolean): CSSProperties => ({
  width: '100%', boxSizing: 'border-box', minHeight: handheld ? 48 : 36,
  padding: '6px 10px', borderRadius: 8, border: `1px solid ${T.field}`, background: T.bg,
  color: T.text, fontFamily: 'inherit', fontSize: handheld ? 17 : 14,
})

export const overlay: CSSProperties = {
  position: 'fixed', inset: 0, background: 'rgba(20,28,40,.45)', zIndex: 1200,
  display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
}

export const dialog: CSSProperties = {
  background: T.bg, color: T.text, borderRadius: 12, width: 'min(560px, 100%)',
  maxHeight: 'calc(100vh - 48px)', overflow: 'auto', boxShadow: '0 24px 60px rgba(0,0,0,.25)',
  padding: 18, display: 'flex', flexDirection: 'column', gap: 12,
}

export const table: CSSProperties = { width: '100%', borderCollapse: 'collapse', fontSize: 14 }
export const th: CSSProperties = {
  textAlign: 'left', padding: '6px 8px', borderBottom: `2px solid ${T.border}`, color: T.muted,
  fontWeight: 600, whiteSpace: 'nowrap', background: T.band, position: 'sticky', top: 0,
}
export const td: CSSProperties = { padding: '6px 8px', borderBottom: `1px solid ${T.border}`, verticalAlign: 'top' }
